import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe('pk_test_51POtSiIPpmakyoBd7356yA5XQY8ABp8877UI1dpSA0Iku8eMZmtgr9WtOexWpvkulCSl4rCv30SCR0nH0vLvwPtF00HtkjX9d5');

const StripeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <Elements stripe={stripePromise}>{children}</Elements>;
};

export default StripeProvider;